function t(e) {
  return o.includes(e.name);
}
const o = [
  "action-hub",
  "arrow-head-down",
  "arrow-head-left",
  "arrow-head-right",
  "arrow-head-up",
  "bars-sort",
  "bento",
  "contract",
  "dock-bottom",
  "dock-float",
  "dock-left",
  "dock-right",
  "dock-top",
  "document-check-on-hold",
  "dot",
  "egosecure",
  "headset",
  "home-stacked",
  "level-0",
  "level-1",
  "level-2",
  "level-3",
  "license",
  "master-data",
  "pin",
  "suem",
  "uem"
];
export {
  t as isCustomIcon
};
